import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import CIcon from "../../../assets/Help/C";
import Control from "../../../assets/Help/Control";
import Delete from "../../../assets/Help/Delete";
import RIcon from "../../../assets/Help/R";
import Shift from "../../../assets/Help/Shift";
import VIcon from "../../../assets/Help/V";
import ZIcon from "../../../assets/Help/Z";
import InterrogationIcon from "../../../assets/icons/Interrogation";
import KeyBoardIcon from "../../../assets/icons/KeyboardIcon";
import MiniFlow from "../../../assets/icons/MiniFlow";
import { useOutsideDrop } from "../../../hooks/useOutsideDrop";
import {
  Container,
  Content,
  Button,
  TipsHeader,
  About,
  Hotkeys,
  Line,
  HelpFlow,
  Tips,
  AboutContent,
  HotkeysSection,
  Tip,
  AboutSection,
  SubSection,
  SectionTitle,
  Description,
  Image,
} from "./styles";

import ConnectionGreen from "../../../assets/Help/connectionGreen.png";
import ConnectionRed from "../../../assets/Help/connectionRed.png";

const HelpButton = () => {
  const [help, setHelp] = useState(false);
  const wrapperRef = useRef(null);

  const clearState = () => setHelp(false);
  const [section, setSection] = useState({ about: false, hotkeys: false });

  useEffect(
    () => () => {
      if (help) {
        setSection({ about: false, hotkeys: false });
      }
    },

    [help]
  );

  useOutsideDrop(wrapperRef, clearState);

  const HandleSpan = () => {
    if (section.about) {
      return (
        <>
          {" > "}
          <span style={{ color: "#40E5A0" }}>Sobre o Fluxo</span>;
        </>
      );
    } else if (section.hotkeys) {
      return (
        <>
          {" > "}
          <span style={{ color: "#40E5A0" }}>Atalhos do teclado</span>;
        </>
      );
    } else return null;
  };

  return (
    <Container ref={wrapperRef}>
      <Button help={help} onClick={() => setHelp((prev) => !prev)}>
        <InterrogationIcon />
      </Button>
      {help && (
        <Content>
          <TipsHeader>
            <Tips>Dicas Rápidas</Tips>
            <HelpFlow>
              <span
                onClick={() => setSection({ about: false, hotkeys: false })}
                style={{ cursor: "pointer" }}
              >
                Início
              </span>
              <HandleSpan />
            </HelpFlow>
          </TipsHeader>
          <Line />
          {!section.about && !section.hotkeys ? (
            <>
              <About
                onClick={(e) => {
                  e.stopPropagation();
                  setSection({ about: true, hotkeys: false });
                }}
              >
                <MiniFlow />
                <AboutContent>
                  <span>Sobre o Fluxo</span>
                  <p>Dicas sobre o funcionamento da modelagem de fluxos</p>
                </AboutContent>
              </About>
              <Hotkeys
                onClick={(e) => {
                  e.stopPropagation();
                  setSection({ about: false, hotkeys: true });
                }}
              >
                <KeyBoardIcon />
                <AboutContent>
                  <span>Atalhos teclados</span>
                  <p>Dicas sobre o funcionamento da modelagem de fluxos</p>
                </AboutContent>
              </Hotkeys>
            </>
          ) : section.about && !section.hotkeys ? (
            <AboutSection>
              <SubSection>
                <SectionTitle>Ligação Verde</SectionTitle>
                <Description>
                  Uma ligação mostrará a cor{" "}
                  <span style={{ color: "#54D651" }}>VERDE</span>
                </Description>
                <Image src={ConnectionGreen} />
              </SubSection>
              <Line />
              <SubSection>
                <SectionTitle>Ligação Vermelha</SectionTitle>
                <Description>
                  Uma ligação mostrará a cor{" "}
                  <span style={{ color: "#F15858" }}>VERMELHA</span>
                </Description>
                <Image src={ConnectionRed} />
              </SubSection>
            </AboutSection>
          ) : (
            <HotkeysSection>
              <Tip>
                <Control />
                <h1>+</h1>
                <CIcon />
                <text>COPIAR</text>
              </Tip>
              <Tip>
                <Control />
                <h1>+</h1>
                <VIcon />
                <text>COLAR</text>
              </Tip>
              <Tip>
                <Control />
                <h1>+</h1>
                <ZIcon />
                <text>DESFAZER</text>
              </Tip>
              <Tip>
                <Control />
                <h1>+</h1>
                <RIcon />
                <text>REFAZER</text>
              </Tip>
              <Tip>
                <Delete />
                <text>EXCLUIR</text>
              </Tip>

              <Tip>
                <Shift height="2.458rem" />
                <text>SELEÇÃO EM CAIXA</text>
              </Tip>
              <Tip>
                <Control height="2.458rem" />
                <text>MULTIPLA SELEÇÃO</text>
              </Tip>
            </HotkeysSection>
          )}
        </Content>
      )}
    </Container>
  );
};

export default HelpButton;
